const {
  empty,
  countryCode,
  organisation,
  street,
  county,
  town,
  locality,
  postcode,
} = require("../shared");
const { createModel, getFieldOptions } = require("../utils");

exports.address = createModel((_, options) => {
  const fieldOptions = getFieldOptions(options);

  return {
    countryCode: countryCode()
      .required()
      .options(fieldOptions),
    organisation: organisation()
      .allow(empty)
      .options(fieldOptions),
    // AddressLine1
    street: street()
      .required()
      .options(fieldOptions),
    // AddressLine2
    locality: locality()
      .allow(empty)
      .options(fieldOptions),
    // AddressLine3
    town: town()
      .required()
      .options(fieldOptions),
    // AddressLine4
    county: county()
      .allow(empty)
      .options(fieldOptions),
    postcode: postcode().options(fieldOptions),
  };
});
